$(document).ready(function () {
  var swiper = new Swiper("#mySwiperse", {
    slidesPerView: 2.5,
    autoHeight: false,
    watchOverflow: true,
    spaceBetween: 27,
    autoplay: true,
    breakpoints: {
      640: {
        slidesPerView: 3.5,
        spaceBetween: 27,
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 27,
      },
      1024: {
        slidesPerView: 5.2,
        spaceBetween: 37,
      },
    },
    pagination: {
      el: ".swiper-pagination",
      nextEl: ".lb-n",
      prevEl: ".lb-p",
      clickable: true,
    },
  });

  $(".vts_card").click(function () {
    var embedContent = $(this).find(".vts_video_content").html();
    $(".vts_video").html(embedContent);
    $(".vts_video_hld").css("display", "flex");
  });

  $(".vts_video_hld").click(function (event) {
    if (event.target === this) {
      $(this).css("display", "none");
      $(".vts_video").empty();
    }
  });

  $(document).keydown(function (e) {
    if (e.key === "Escape") {
      $(".vts_video_hld").css("display", "none");
      $(".vts_video").empty();
    }
  });
});

$(document).ready(function () {
  function highlightLastWords(selector, numWords) {
    $(selector).each(function () {
      var text = $(this).text();
      var words = text.split(" ");
      if (words.length > numWords) {
        var lastWords = words.slice(-numWords).join(" ");
        var initialText = words.slice(0, -numWords).join(" ");
        $(this).html(
          initialText +
            ' <span class="testimonials-color">' +
            lastWords +
            "</span>"
        );
      }
    });
  }

  highlightLastWords(".h1.vts_tite", 2); // This highlights the last 2 words
});
